document.addEventListener('DOMContentLoaded', function() {
  var shippingStartDays = 3; // Minimum days for delivery
  var shippingEndDays = 7;  // Maximum days for delivery

  var startDate = new Date();
  startDate.setDate(startDate.getDate() + shippingStartDays);
  var endDate = new Date();
  endDate.setDate(endDate.getDate() + shippingEndDays);

  // Check if start date or end date falls on a Sunday (0), if so add one day
  if (startDate.getDay() === 0) {
    startDate.setDate(startDate.getDate() + 1);
  }
  if (endDate.getDay() === 0) {
    endDate.setDate(endDate.getDate() + 1);
  }

  // Format dates as "MMM dd"
  var options = { month: 'short', day: 'numeric' };
  var formattedStartDate = startDate.toLocaleDateString('en-US', options);
  var formattedEndDate = endDate.toLocaleDateString('en-US', options);

  var deliveryText = 'Estimated Delivery: ' + formattedStartDate + ' - ' + formattedEndDate;
  document.getElementById('estimated-delivery-date').textContent = deliveryText;
});

